import React from 'react'

const WhatWeAre = () => {
  return (
    <div>WhatWeAre</div>
  )
}

export default WhatWeAre